import { Widget } from "@foretagsplatsen/widgetjs";
import legendItemWidget from "./legendItemWidget.js";

/**
 * `LegendWidget` creates and renders a list of legendItemWidget which gives
 * information on its corresponding chart.
 *
 * @param {{}[]} itemOptions - Litterals of parameters summarizing each legend item.
 * See legendItemWidget for a list of availables parameters.
 * @param {string} legendId - Unique string representing the list of legend items.
 * @param {string} legendClass - Additional class(es) to be added to the widget ul.
 * @param {string} [legendItemClass] - Additional classes for the legend items.
 * @param {Renderable} chart - Chart widget rendering the values to which the legend
 * items are refering to.
 */
export default class LegendWidget extends Widget {
	constructor({
		itemOptions = [],
		legendId,
		legendClass = "",
		legendItemClass,
		chart,
	}) {
		super(...arguments);

		this._itemOptions = itemOptions;
		this._legendId = legendId;
		this._legendClass = legendClass;
		this._legendItemClass = legendItemClass;
		this._chart = chart;

		this._items = this._buildItemsFromOptions(this._itemOptions);
	}

	setValues(values) {
		Object.keys(values).forEach((seriesId) => {
			const legendItem = this._getLegendItemById(seriesId);
			legendItem?.setValue(values[seriesId]);
		});
	}

	renderContentOn(html) {
		html.div(
			{
				id: "business-chart-legend-container",
				class: "legend-container",
				"data-help": "legend-container",
			},
			html.ul(
				{ id: this._legendId, class: ["legend", this._legendClass] },
				this._items,
			),
		);
	}

	_setItems(itemOptions) {
		this._items = this._buildItemsFromOptions(itemOptions);
	}

	_getLegendItemById(id) {
		return this._items.find((item) => item.getSeriesId() === id);
	}

	_buildItemsFromOptions(itemOptions) {
		const visibleItems = itemOptions.filter((item) => !item.isHidden);

		return visibleItems.map((options) =>
			legendItemWidget({
				legendItemClass: this._legendItemClass,
				chart: this._chart,
				...options,
			}),
		);
	}
}
